/*
 * @Description: 会议基本信息
 * @Author: 山淑兰
 * @Date: 2019-12-28 00:34:00
 * @LastEditTime : 2019-12-28 00:35:49
 * @LastEditors  : 山淑兰
 */
export class InitMeetingInfo {
  m: string = "";
}
